import React from 'react';
import { Table, Row, Col, Input } from 'antd';
import { GLOBAL_TABLE_SIZE } from 'global_config/constant-global';
import {
	LR_SEL_EXAMS,
	LR_OTHER_INFO,
	LR_DEL_SECTIONS,
	LR_REQUEST_TYPE,
	LR_EDIT_SEL_EXAM_REF,
} from 'modules/main/lab_request/steps/constants';
import { fetchExamsByReqId } from 'services/lab_request/labRequest';
import { Form } from 'antd';

import './table.css';
import { index } from 'd3-array';

const columns = [
	// {
	// 	title: 'PANEL',
	// 	dataIndex: ['selectedPanel', 'panelName'],
	// 	width: 200,
	// 	defaultSortOrder: 'ascend',
	// 	sorter: (a, b) => {
	// 		const aPanelName = a.selectedPanel ? a.selectedPanel.panelName : '';
	// 		const bPanelName = b.selectedPanel ? b.selectedPanel.panelName : '';

	// 		return aPanelName.localeCompare(bPanelName);
	// 	},
	// 	// align: 'center',
	// },
	{
		title: 'SECTION',
		dataIndex: ['selectedSection', 'sectionName'],
		width: 200,
	},
	{
		title: 'EXAM NAME',
		dataIndex: 'examName',
		width: 300,
		// align: 'center',
	},
	// {
	// 	title: 'SPECIMEN',
	// 	dataIndex: ['selectedSpecimen', 'specimenName'],
	// 	width: 200,
	// 	// align: 'center',
	// 	render: text => text.toString().toUpperCase()
	// }
];

const cancelledPanelCols = [
	{
		title: 'CANCELLED REQUEST',
		dataIndex: ['sectionName'],
		width: 200,
	},
	{
		title: 'SPECIMEN',
		dataIndex: 'specimenName',
		width: 200,
	},
	{
		title: 'REASON',
		width: 300,
		render: (text, record) => (
			<Form.Item
				style={{ marginBottom: '0px' }}
				name={['reasons', `${record.sectionID}-${record.specimenID}`]}
				rules={[{ required: true, message: 'This field is required' }]}
			>
				<Input />
			</Form.Item>
		),
	},
];

class SummaryTable extends React.Component {
	state = {
		exams: [],
		cancelledSections: [],
		reqType: sessionStorage.getItem(LR_REQUEST_TYPE),
	};

	async componentDidMount() {
		const sessionExams = sessionStorage.getItem(LR_SEL_EXAMS);

		// Variables for Edit Module
		const otherInfo = sessionStorage.getItem(LR_OTHER_INFO);

		const requestID = otherInfo ? JSON.parse(otherInfo).requestID : null;

		// const qexams = await fetchExamsByReqId(requestID);

		// Store selected exams from api to session storage
		// This will trigger if session exam has no value
		// and when user is in edit module.
		// Specifically when user jump to summary page using the steps link
		if (!sessionExams && requestID) {
			const qexams = await fetchExamsByReqId(requestID);

			console.log(qexams);

			let zexams = [];

			qexams.forEach(tier1 => {
				tier1.contents.forEach(tier2 => {
					const tmpRoot = {};
					const tmpPanel = {};
					const tmpSpecimen = {};
					const tmpSection = {};

					tmpSpecimen.specimenID = tier1.specimenID;
					tmpSpecimen.specimenName = tier1.specimenName;

					tmpSection.sectionID = tier1.sectionID;
					tmpSection.sectionName = tier1.sectionName;
					tmpSection.sectionCode = tier1.sectionCode;

					tmpPanel.panelID = tier2.panelID;
					tmpPanel.panelName = tier2.panelName;
					tmpPanel.panelCode = tier2.panelCode;

					tmpRoot.examID = tier2.examID;
					tmpRoot.examName = tier2.examRequestName;
					tmpRoot.examCode = tier2.examRequestCode;
					tmpRoot.selectedPanel = tier2.panelID ? tmpPanel : null;
					tmpRoot.selectedSpecimen = tmpSpecimen;
					tmpRoot.selectedSection = tmpSection;
					tmpRoot.isDisabled = false;
					tmpRoot.isLocked = tier1.status !== 'Open';

					zexams.push(tmpRoot);
				});
			});

			console.log(zexams);

			sessionStorage.setItem(LR_SEL_EXAMS, JSON.stringify(zexams));
		}

		const cachedExams = JSON.parse(sessionStorage.getItem(LR_SEL_EXAMS));
		const exams = cachedExams.map(cachedExam => ({ ...cachedExam, key: cachedExam.examID }));

		console.log(exams);

		//added if statement to run cancelled section if editing ACD 06012023
		//ito ang fix para sa unselected exams na nagkakaroon ng section id null

		// if (this.state.reqType === 'edit') {
		// 	const sessDelSections = JSON.parse(sessionStorage.getItem(LR_DEL_SECTIONS));
		// 	const cancelledSections = sessDelSections.map(section => ({
		// 		...section[0].selectedSection,
		// 		key: section[0].selectedSection['sectionID'],
		// 	}));
		// 	console.log(sessDelSections);
		// 	console.log(cancelledSections);
		// 	this.setState({ exams });
		// } else {
		// 	//will set state if not editing
		// 	this.setState({ exams });
		// }

		// istian 07052024
		// istian dati na base ung code sa unselected exam madaming error kaya nag base ako sa storage
		// new selected and previuos selected from create

		if (this.state.reqType === 'edit') {
			const PreviousSelectedExams = JSON.parse(sessionStorage.getItem(LR_EDIT_SEL_EXAM_REF));
			const selectedExams = JSON.parse(sessionStorage.getItem(LR_SEL_EXAMS));

			const selectedKeys = new Set(
				selectedExams.map(
					item => `${item.selectedSection.sectionID}-${item.selectedSpecimen.specimenID}`,
				),
			);

			const removedFromPrevious = PreviousSelectedExams.filter(
				item =>
					!selectedKeys.has(
						`${item.selectedSection.sectionID}-${item.selectedSpecimen.specimenID}`,
					),
			);

			const cancelledSectionsMap = new Map();

			removedFromPrevious.forEach(item => {
				console.log(item);
				const key = `${item.selectedSection.sectionID}-${item.selectedSpecimen.specimenID}`;
				if (!cancelledSectionsMap.has(key)) {
					cancelledSectionsMap.set(key, {
						...item.selectedSection,
						key: key,
						specimenID: item.selectedSpecimen.specimenID,
						examsRemoved: 0,
						specimenName: item.selectedSpecimen.specimenName,
					});
				}
				cancelledSectionsMap.get(key).examsRemoved++;
			});

			const cancelledSections = [];
			cancelledSectionsMap.forEach(section => {
				const totalExamsInSection = PreviousSelectedExams.filter(
					item =>
						`${item.selectedSection.sectionID}-${item.selectedSpecimen.specimenID}` === section.key,
				).length;

				if (section.examsRemoved === totalExamsInSection) {
					cancelledSections.push(section);
				}
			});

			console.log(cancelledSections);

			this.setState({ exams, cancelledSections });
		} else {
			this.setState({ exams });
		}
	}

	render() {
		const { exams, cancelledSections, reqType } = this.state;

		return (
			<div>
				<Row>
					<Col sm={{ span: 24 }} lg={{ span: 18, offset: 3 }}>
						<div className="summary-step-table">
							<Table
								size={GLOBAL_TABLE_SIZE}
								dataSource={exams}
								// @ts-ignore
								columns={columns}
								pagination={false}
							/>
						</div>
					</Col>
				</Row>
				{cancelledSections.length > 0 && reqType !== 'create' ? (
					<Row style={{ marginTop: 20 }}>
						<Col sm={{ span: 24 }} lg={{ span: 18, offset: 3 }}>
							<div className="summary-step-table">
								<Table
									size={GLOBAL_TABLE_SIZE}
									dataSource={cancelledSections}
									// @ts-ignore
									columns={cancelledPanelCols}
									pagination={false}
								/>
							</div>
						</Col>
					</Row>
				) : (
					<></>
				)}
			</div>
		);
	}
}

export default SummaryTable;
